import { render, staticRenderFns } from "./Error_404.vue?vue&type=template&id=2681bfe8&"
import script from "./Error_404.vue?vue&type=script&lang=js&"
export * from "./Error_404.vue?vue&type=script&lang=js&"
import style0 from "./Error_404.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports